<template>
      <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
      <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css" rel="stylesheet">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
      <!--Main Navigation-->
      <header>
            <!-- Navbar Component -->
            <Navbar :usuario="usuario" :perfil="rol" :modulo="Number(modulo)" @logout="handleLogout" />

            <!-- Sidebar -->
            <nav id="sidebarMenu" class="collapse d-lg-block sidebar collapse bg-white">
                  <div class="accordion" id="accordionExample">
                        <div class="accordion-item" v-if="true">
                              <div class="inicio" @click="menu_principal()">
                                    <i class="material-icons">home</i>&nbsp;&nbsp;Inicio
                              </div>
                        </div>
                        <!--
Módulo: Administracion De Usuarios
-->
                        <div v-if="modulo == 1">
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne" :disabled="menuProcesos === 0"
                                                @click="menuProcesos !== 0 && toggleProcesos">
                                                <i class="material-icons">settings</i>
                                                &nbsp;&nbsp;Procesos
                                          </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 1 && procesosMenuOpen }"
                                          aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in adminProcesosRoutes" :key="'admin-procesos-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                          <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                aria-expanded="false" aria-controls="collapseTwo"
                                                :disabled="menuReportes === 0"
                                                @click="menuReportes !== 0 && toggleReportes">
                                                <i class="material-icons">leaderboard</i>
                                                &nbsp;&nbsp;Reportes
                                          </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 2 && reportesMenuOpen }"
                                          aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in adminReportesRoutes" :key="'admin-reportes-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                          <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree"
                                                :disabled="menuParametros === 0"
                                                @click="menuParametros !== 0 && toggleParametros">
                                                <i class="material-icons">grid_view</i>
                                                &nbsp;&nbsp;Parámetros
                                          </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 3 && parametrosMenuOpen }"
                                          aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in adminParametrosRoutes" :key="'admin-parametros-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>

                                    </div>
                              </div>
                        </div>
                        <!--
Módulo: Registros Médicos
-->
                        <div v-if="modulo == 2">
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne" :disabled="menuProcesos === 0"
                                                @click="menuProcesos !== 0 && toggleProcesos">
                                                <i class="material-icons">settings</i>
                                                &nbsp;&nbsp;Procesos
                                          </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 1 && procesosMenuOpen }"
                                          aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in medicalProcesosRoutes" :key="'medical-procesos-' + index">
                                                            <router-link class="nav-link" :to="route.path">
                                                                  {{ route.name }}
<!--
                                                                  <span v-if="route.name === 'Citas'">({{ numeroCitas }})</span>
                                                                  <span v-if="route.name === 'Atenciones'">({{ numeroAtenciones }})</span>
                                                                  <span v-if="route.name === 'Interconsultas'">({{ numeroInterconsultas }})</span>
                                                                  <span v-if="route.name === 'Referencias y Derivaciones'">({{ numeroReferencias }})</span>
-->
                                                            </router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                          <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                aria-expanded="false" aria-controls="collapseTwo"
                                                :disabled="menuReportes === 0"
                                                @click="menuReportes !== 0 && toggleReportes">
                                                <i class="material-icons">leaderboard</i>
                                                &nbsp;&nbsp;Reportes
                                          </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 2 && reportesMenuOpen }"
                                          aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in medicalReportesRoutes" :key="'medical-reportes-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                          <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree"
                                                :disabled="menuParametros === 0"
                                                @click="menuParametros !== 0 && toggleParametros">
                                                <i class="material-icons">grid_view</i>
                                                &nbsp;&nbsp;Parámetros
                                          </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 3 && parametrosMenuOpen }"
                                          aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in medicalParametrosRoutes" :key="'medical-parametros-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                        </div>
                        <!--
Módulo: Financiero
-->
                        <div v-if="modulo == 3">
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne" :disabled="menuProcesos === 0"
                                                @click="menuProcesos !== 0 && toggleProcesos">
                                                <i class="material-icons">settings</i>
                                                &nbsp;&nbsp;Procesos
                                          </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 1 && procesosMenuOpen }"
                                          aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in financialProcesosRoutes" :key="'financial-procesos-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                          <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                aria-expanded="false" aria-controls="collapseTwo"
                                                :disabled="menuReportes === 0"
                                                @click="menuReportes !== 0 && toggleReportes">
                                                <i class="material-icons">leaderboard</i>
                                                &nbsp;&nbsp;Reportes
                                          </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 2 && reportesMenuOpen }"
                                          aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in financialReportesRoutes" :key="'financial-reportes-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                              <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                          <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree"
                                                :disabled="menuParametros === 0"
                                                @click="menuParametros !== 0 && toggleParametros">
                                                <i class="material-icons">grid_view</i>
                                                &nbsp;&nbsp;Parámetros
                                          </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse"
                                          :class="{ show: selectedOption === 3 && parametrosMenuOpen }"
                                          aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                          <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                                style="height: 500px; overflow: auto;">
                                                <li class="list-group-item py-1">
                                                      <div v-for="(route, index) in financialParametrosRoutes" :key="'financial-parametros-' + index">
                                                            <router-link class="nav-link" :to="route.path">{{ route.name }}</router-link>
                                                      </div>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                        </div>

                        <!--
Módulo: Dashboards
-->
<div v-if="modulo == 4">

  <!-- Citas -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button"
        data-bs-toggle="collapse" data-bs-target="#collapseOne"
        aria-expanded="true" aria-controls="collapseOne"
        :disabled="menuProcesos === 0"
        @click="menuProcesos !== 0 && toggleProcesos">
        <i class="material-icons">calendar_month</i>
        &nbsp;&nbsp;Citas
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse"
      :class="{ show: selectedOption === 1 && procesosMenuOpen }"
      aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <ul class="collapse show list-group list-group-flush" style="max-height:400px;overflow:auto">
        <li v-for="(route, index) in dashboardsCitasRoutes"
            :key="'citas-' + index"
            class="list-group-item py-1">
          <router-link class="nav-link d-flex align-items-center gap-2" :to="route.path">
            <span class="material-symbols-outlined" style="font-size:15px">{{ route.meta.icono }}</span>
            {{ route.meta.title }}
            <span v-if="route.meta.nuevo" class="badge bg-primary ms-auto" style="font-size:9px">Nuevo</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>

  <!-- Atenciones -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button"
        data-bs-toggle="collapse" data-bs-target="#collapseTwo"
        aria-expanded="false" aria-controls="collapseTwo"
        :disabled="menuReportes === 0"
        @click="menuReportes !== 0 && toggleReportes">
        <i class="material-icons">monitor_heart</i>
        &nbsp;&nbsp;Atenciones
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse"
      :class="{ show: selectedOption === 2 && reportesMenuOpen }"
      aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <ul class="collapse show list-group list-group-flush" style="max-height:400px;overflow:auto">
        <li v-for="(route, index) in dashboardsAtencionesRoutes"
            :key="'atenciones-' + index"
            class="list-group-item py-1">
          <router-link class="nav-link d-flex align-items-center gap-2" :to="route.path">
            <span class="material-symbols-outlined" style="font-size:15px">{{ route.meta.icono }}</span>
            {{ route.meta.title }}
            <span v-if="route.meta.nuevo" class="badge bg-primary ms-auto" style="font-size:9px">Nuevo</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>

  <!-- Pacientes -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button"
        data-bs-toggle="collapse" data-bs-target="#collapseThree"
        aria-expanded="false" aria-controls="collapseThree"
        :disabled="menuParametros === 0"
        @click="menuParametros !== 0 && toggleParametros">
        <i class="material-icons">group</i>
        &nbsp;&nbsp;Pacientes
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse"
      :class="{ show: selectedOption === 3 && parametrosMenuOpen }"
      aria-labelledby="headingThree" data-bs-parent="#accordionExample">
      <ul class="collapse show list-group list-group-flush" style="max-height:400px;overflow:auto">
        <li v-for="(route, index) in dashboardsPacientesRoutes"
            :key="'pacientes-' + index"
            class="list-group-item py-1">
          <router-link class="nav-link d-flex align-items-center gap-2" :to="route.path">
            <span class="material-symbols-outlined" style="font-size:15px">{{ route.meta.icono }}</span>
            {{ route.meta.title }}
            <span v-if="route.meta.nuevo" class="badge bg-primary ms-auto" style="font-size:9px">Nuevo</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>

  <!-- Facturación y pagos — cuarto acordeón -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFour">
      <button class="accordion-button collapsed" type="button"
        data-bs-toggle="collapse" data-bs-target="#collapseFour"
        aria-expanded="false" aria-controls="collapseFour"
        @click="toggleFacturacion">
        <i class="material-icons">receipt_long</i>
        &nbsp;&nbsp;Facturación y pagos
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse"
      :class="{ show: selectedOption === 4 && facturacionMenuOpen }"
      aria-labelledby="headingFour" data-bs-parent="#accordionExample">
      <ul class="collapse show list-group list-group-flush" style="max-height:400px;overflow:auto">
        <li v-for="(route, index) in dashboardsFacturacionRoutes"
            :key="'facturacion-' + index"
            class="list-group-item py-1">
          <router-link class="nav-link d-flex align-items-center gap-2" :to="route.path">
            <span class="material-symbols-outlined" style="font-size:15px">{{ route.meta.icono }}</span>
            {{ route.meta.title }}
            <span v-if="route.meta.nuevo" class="badge bg-primary ms-auto" style="font-size:9px">Nuevo</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>

</div>                
                        <!--
Ayuda
-->
                        <div class="accordion-item">
                              <h2 class="accordion-header" id="headingFive">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                          data-bs-target="#collapseFive" aria-expanded="false"
                                          aria-controls="collapseFive" :disabled="menuAyuda === 0"
                                          @click="menuAyuda !== 0 && toggleAyuda">
                                          <i class="material-icons">help_outline</i>
                                          &nbsp;&nbsp;Ayuda
                                    </button>
                              </h2>
                              <div id="collapseFive" class="accordion-collapse collapse"
                                    :class="{ show: selectedOption === 5 && ayudaMenuOpen }"
                                    aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                    <ul id="collapseExample1" class="collapse show list-group list-group-flush"
                                          style="height: 500px; overflow: auto;">
                                          <li class="list-group-item py-1">
                                                <router-link class="nav-link" to="/faq">FAQ (Preguntas
                                                      Frecuentes)</router-link>
                                                <router-link class="nav-link" to="/contacto">Información de
                                                      Contacto</router-link>
                                                <router-link class="nav-link" to="/privacypolicy">Políticas de Privacidad
                                                      y Seguridad</router-link>
                                          </li>
                                    </ul>
                              </div>
                        </div>
                  </div>
            </nav>
            <!-- Sidebar -->

      </header>
      <!--Main Navigation-->

      <!--Main layout-->
      <main style="margin-top: 20px;">
            <div class="container pt-4"></div>
      </main>
      <!--Main layout-->
</template>
<script>
import jwt_decode from 'jwt-decode';

import Navbar from '@/components/Navbar.vue';
import inactividadMixin from '@/mixins/inactividadMixin';

import { routes as adminProcesosRoutes } from '@/router/mod/AdminProcesos.js';
import { routes as adminReportesRoutes } from '@/router/mod/AdminReportes.js';
import { routes as adminParametrosRoutes } from '@/router/mod/AdminParametros.js';
import { routes as medicalProcesosRoutes } from '@/router/mod/MedicalProcesos.js';
import { routes as medicalReportesRoutes } from '@/router/mod/MedicalReportes.js';
import { routes as medicalParametrosRoutes } from '@/router/mod/MedicalParametros.js';
import { routes as financialProcesosRoutes } from '@/router/mod/FinancialProcesos.js';
import { routes as financialReportesRoutes } from '@/router/mod/FinancialReportes.js';
import { routes as financialParametrosRoutes } from '@/router/mod/FinancialParametros.js';
import { routes as dashboardsCitasRoutes } from '@/router/mod/DashboardsCitas.js';
import { routes as dashboardsAtencionesRoutes } from '@/router/mod/DashboardsAtenciones.js';
import { routes as dashboardsPacientesRoutes } from '@/router/mod/DashboardsPacientes.js';
import { routes as dashboardsFacturacionRoutes } from '@/router/mod/DashboardsFacturacion.js';
export default {
      mixins: [inactividadMixin],
      props: {
            selectedOption: Number
      },
      components: {
            Navbar
      },
      data() {
            return {
                  token: '',
                  rol: '',
                  usuario: '',
                  nombreEmpresa: '',
                  idEmpresa: 0,
                  modulo: 1,
                  procesos: false,
                  parametros: false,
                  administracion: false,
                  reportes: false,
                  ayuda: false,
                  menuParametros: 0,
                  menuProcesos: 0,
                  menuReportes: 0,
                  menuAyuda: 0,
                  procesosMenuOpen: false,
                  reportesMenuOpen: false,
                  parametrosMenuOpen: false,
                  facturacionMenuOpen: false,
                  ayudaMenuOpen: false,
                  adminProcesosRoutes,
                  adminReportesRoutes,
                  adminParametrosRoutes,
                  medicalProcesosRoutes,
                  medicalReportesRoutes,
                  medicalParametrosRoutes,
                  financialProcesosRoutes,
                  financialReportesRoutes,
                  financialParametrosRoutes,
                  dashboardsCitasRoutes,
                  dashboardsAtencionesRoutes,
                  dashboardsPacientesRoutes,
                  dashboardsFacturacionRoutes,
                  // numeroCitas: 0,
                  // numeroAtenciones: 0,
                  // numeroInterconsultas: 0,
                  // numeroReferencias: 0,
            }
      },
/*       computed: {
            numeroCitas() {
                  return this.$store.state.numeroCitas;
            },
            numeroAtenciones() {
                  return this.$store.state.numeroAtenciones;
            },
            numeroInterconsultas() {
                  return this.$store.state.numeroInterconsultas;
            },
            numeroReferencias() {
                  return this.$store.state.numeroReferencias;
            },
      }, */
/*       computed: {
            buttonProcessClass() {
                  return this.menuProcesos === 1 ? 'accordion-button collapsed' : 'accordion-button:disabled';
            },
            buttonReportsClass() {
                  return this.menuReportes === 1 ? 'accordion-button collapsed' : 'accordion-button:disabled';
            },
            buttonParamsClass() {
                  return this.menuParametros === 1 ? 'accordion-button collapsed' : 'accordion-button:disabled';
            },
            getIdEmpresa() {
                  if (typeof window !== 'undefined' && window.sessionStorage) {
                        return sessionStorage.getItem('idEmpresa');
                  }
                  return null;
            },
            getNombreEmpresa() {
                  if (typeof window !== 'undefined' && window.sessionStorage) {
                        return sessionStorage.getItem('nombreEmpresa');
                  }
                  return null;
            },
            medicoInterconsultaLink() {
                  const idMedico = window.sessionStorage.getItem("idMedico");
                  return `/medico_interconsulta/${idMedico}`;
            },
            esSuscriptor() {
                  const suscriptor = Number(window.sessionStorage.getItem("suscriptor"));
                  return suscriptor === 1;
            } 
      }, */
/*        created() {
            this.fetchNumeroCitas();
            this.fetchNumeroAtenciones();
            this.fetchNumeroInterconsultas();
            this.fetchNumeroReferencias();
      }, */
      mounted() {
            this.valorToken()
            this.authorization()
            this.initializeMenuSettings();
            // this.fetchNumeroCitas();
            // this.fetchNumeroAtenciones();
            // this.fetchNumeroInterconsultas();
            // this.fetchNumeroReferencias();
      },
      methods: {
            toggleProcesos() {
                  if (this.selectedOption === 1) {
                        this.procesosMenuOpen = !this.procesosMenuOpen;
                        if (this.procesosMenuOpen) {
                              this.reportesMenuOpen = false;
                              this.parametrosMenuOpen = false;
                              this.ayudaMenuOpen = false;
                              this.facturacionMenuOpen = false
                        }
                  }
            },
            toggleReportes() {
                  if (this.selectedOption === 2) {
                        this.reportesMenuOpen = !this.reportesMenuOpen;
                        if (this.reportesMenuOpen) {
                              this.procesosMenuOpen = false;
                              this.parametrosMenuOpen = false;
                              this.ayudaMenuOpen = false;
                              this.facturacionMenuOpen = false
                        }
                  }
            },
            toggleParametros() {
                  if (this.selectedOption === 3) {
                        this.parametrosMenuOpen = !this.parametrosMenuOpen;
                        if (this.parametrosMenuOpen) {
                              this.procesosMenuOpen = false;
                              this.reportesMenuOpen = false;
                              this.ayudaMenuOpen = false;
                              this.facturacionMenuOpen = false
                        }
                  }
            },
            toggleFacturacion() {
              if (this.selectedOption === 4) {
                this.facturacionMenuOpen = !this.facturacionMenuOpen
                if (this.facturacionMenuOpen) {
                  this.procesosMenuOpen   = false
                  this.reportesMenuOpen   = false
                  this.parametrosMenuOpen = false
                  this.ayudaMenuOpen      = false
                }
              }
            },
            toggleAyuda() {
              if (this.selectedOption === 5) {
                this.ayudaMenuOpen = !this.ayudaMenuOpen
                if (this.ayudaMenuOpen) {
                  this.procesosMenuOpen    = false
                  this.reportesMenuOpen    = false
                  this.parametrosMenuOpen  = false
                  this.facturacionMenuOpen = false
                }
              }
            },
            async menu_principal() {
                  window.sessionStorage.setItem('modulo', "0");
                  //                  this.modulo = p_modulo;
                  //                  window.sessionStorage.setItem('modulo', this.modulo);
                  //                  this.$router.push('/MenuPrincipal');
                  this.$router.replace({ path: '/empty' }).then(() => {
                        this.$router.replace('/MenuPrincipal');
                  });
            },
            async authorization() {
                  this.token = window.sessionStorage.getItem("token");
                  this.rol = window.sessionStorage.getItem("rol");
                  this.usuario = window.sessionStorage.getItem("usuario");
                  this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
                  this.nombreEmpresa = window.sessionStorage.getItem("nombreEmpresa");
                  this.modulo = window.sessionStorage.getItem("modulo");
                  //                  alert('navbar: ' + this.modulo);
                  if (this.rol == "ADMINISTRADOR") {
                        this.procesos = true;
                        this.parametros = true;
                        this.administracion = true;
                        this.reportes = true;
                        this.ayuda = true;
                  }
            },
            handleLogout(action) {
                  if (action === 'logout') {
                        this.logout();
                        this.$router.push('/');
                  } else if (action === 'changeUser') {
                        this.logout();
                        this.$router.push('/Login');
                  }
            },
            logout() {
                  window.sessionStorage.removeItem("token");
                  window.sessionStorage.removeItem("rol");
                  window.sessionStorage.removeItem("usuario");
                  console.log(window.sessionStorage.getItem("token"));
                  console.log(window.sessionStorage.getItem("rol"));
                  console.log(window.sessionStorage.getItem("usuario"));
            },
            async valorToken() {
                  const token = window.sessionStorage.getItem("token");
                  if (!token || jwt_decode(token).exp * 1000 < Date.now()) {
                        this.$router.push('/Login');
                  }
            },
/* 
            fetchNumeroCitas() {
                  // Simulate an API call
                  fetch('http://localhost:8080/api/v1/vwcitas/estadocita/'+this.idEmpresa+'/PROGRAMADA')
                  .then(response => response.json())
                  .then(data => {
                  this.numeroCitas = data.length; // Or however you get the number
                  })
                  .catch(error => {
                  console.error('Error fetching número de citas:', error);
                  });
            },
            fetchNumeroAtenciones() {
                  // Simulate an API call
                  fetch('http://localhost:8080/api/v1/vwatencions/empresa-estadoatencion/'+this.idEmpresa+'/PENDIENTE')
                  .then(response => response.json())
                  .then(data => {
                  this.numeroAtenciones = data.length; // Or however you get the number
                  })
                  .catch(error => {
                  console.error('Error fetching número de citas:', error);
                  });
            },
            fetchNumeroInterconsultas() {
                  // Simulate an API call
                  fetch('http://localhost:8080/api/v1/vwinterconsultas/idmedico/'+window.sessionStorage.getItem("idMedico"))
                  .then(response => response.json())
                  .then(data => {
                  this.numeroInterconsultas = data.length; // Or however you get the number
                  })
                  .catch(error => {
                  console.error('Error fetching número de citas:', error);
                  });
            },
            fetchNumeroReferencias() {
                  // Simulate an API call
                  fetch('http://localhost:8080/api/v1/vwreferencias/idmedico/'+window.sessionStorage.getItem("idMedico"))
                  .then(response => response.json())
                  .then(data => {
                  this.numeroReferencias = data.length; // Or however you get the number
                  })
                  .catch(error => {
                  console.error('Error fetching número de citas:', error);
                  });
            },
             */
            initializeMenuSettings() {
                  this.menuParametros = parseInt(window.sessionStorage.getItem('menuParametros'), 10) || 0;
                  this.menuProcesos = parseInt(window.sessionStorage.getItem('menuProcesos'), 10) || 0;
                  this.menuReportes = parseInt(window.sessionStorage.getItem('menuReportes'), 10) || 0;
                  this.menuAyuda = parseInt(window.sessionStorage.getItem('menuAyuda'), 10) || 0;
            }
      }
}
</script>
<style src="@/assets/css/menu_azul.css" scoped></style>
<!-- <style src="@/assets/css/breadcrumbs.css"></style> -->
<!-- <style scoped>
.icono-tamano {
      font-size: 48px;
}

.offcanvas-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
}

.separador-con-texto {
      display: block;
      text-align: center;
      font-weight: bold;
      color: #007bff;
      margin: 10px 0;
}
</style> -->